export const SEND_QUERY_REQUEST = "SEND_QUERY_REQUEST";
export const SEND_QUERY_SUCCESS = "SEND_QUERY_SUCCESS";
export const SEND_QUERY_FAILURE = "SEND_QUERY_FAILURE";
